// Externe analytics-scripts pas laden NA hydratie.
// Deze scripts kunnen de DOM muteren (links/teksten). Wanneer ze vóór hydratie
// draaien, komt de server-HTML niet meer overeen met de React-tree.
//
// Ranktool wordt bewust pas na hydration geladen, zodat het de server-HTML niet
// kan wijzigen voordat React de pagina heeft overgenomen.

type ScriptDef = { src: string; attrs?: Record<string, string> };

const SCRIPTS: ScriptDef[] = [
  { src: "https://ranktool.nl/rt.js?id=1ed8c61f8a096ee0a5d0ebef62d89faa" },
];

const injectAll = () => {
  for (const { src, attrs } of SCRIPTS) {
    if (document.querySelector(`script[src="${src}"]`)) continue;
    const el = document.createElement("script");
    el.src = src;
    el.async = true;
    for (const [k, v] of Object.entries(attrs ?? {})) el.setAttribute(k, v);
    document.head.appendChild(el);
  }
};

// Alleen op het live domein laden. In de Lovable-preview faalt Ranktool's eigen
// tracking-endpoint (client-analytics-track → 400 "Session not found").
const LIVE_HOSTS = ["magicprint.nl", "www.magicprint.nl"];

export const loadThirdPartyScripts = () => {
  if (typeof window === "undefined") return;
  if (SCRIPTS.length === 0) return;
  if (!LIVE_HOSTS.includes(window.location.hostname)) return;
  const run = () => window.setTimeout(injectAll, 1500);
  if (document.readyState === "complete") run();
  else window.addEventListener("load", run, { once: true });
};
